import { FC, Suspense, lazy } from "react";
import { Benefit } from "@commons-monorepo/index";
import { WidgetProps, WidgetType } from "@commons-monorepo/index";

const Benefits1 = lazy(() => import("./skins/benefits-1/benefits-1"));
const Benefits2 = lazy(() => import("./skins/benefits-2/benefits-2"));
const Benefits3 = lazy(() => import("./skins/benefits-3/benefits-3"));

const Benefits: FC<
  WidgetProps<Benefit[], { highlight_background: boolean }>
> = ({ id, data, config, type }) => {

  return data ? (
    <div id={id}>
      <Suspense>
        {type === WidgetType.BENEFITS_1 && (
          <Benefits1 benefits={data} highLight={config.highlight_background} />
        )}
        {type === WidgetType.BENEFITS_2 && (
          <Benefits2 benefits={data} highLight={config.highlight_background} />
        )}
        {type === WidgetType.BENEFITS_3 && (
          <Benefits3 benefits={data} highLight={config.highlight_background} />
        )}
      </Suspense>
    </div>
  ) : (
    <></>
  );
};

export default Benefits;
